// Central content for the Change Ur Story - Master Every Interview landing page

export const BRAND = {
  name: "Change Ur Story",
  tagline: "For Job Seekers Who Want Results",
};

export const STATS = [
  { value: "85%", label: "Got Promoted" },
  { value: "40%", label: "Salary Increase" },
  { value: "50+", label: "Corporate Clients" },
  { value: "2,000+", label: "Professionals Helped" },
];

export const LOGOS = [
  "Indian Air Force", "Indian Navy", "Indian Army", "John Deere", "WTW", "Infosys", "ONGC", "Google",
  "Abbott", "Autoliv", "Citi", "Larsen & Toubro", "Lumeris", "Workday", "Barclays", "Pfizer",
  "JPMorgan Chase", "Alstom", "Deloitte", "ANZ", "HMEL", "NHPC Limited", "EY", "Boeing",
  "Microsoft", "Electronic Arts", "Mastercard", "Chargebee", "PepsiCo", "Bayer", "ExxonMobil", "Caterpillar",
  "Amazon", "Axis Bank", "WiseTech Global", "Swiggy", "IIM Rohtak", "IIM Ahmedabad", "Flipkart", "Bain & Company",
];

export const TOOLS = [
  {
    name: "Overcome Nervousness",
    icon: "Shield",
    desc: "Stop freezing up when asked tough questions. Learn techniques to stay calm under pressure.",
    tag: "Confidence",
  },
  {
    name: "Perfect Your Answers",
    icon: "MessageSquare",
    desc: "Learn how to structure your stories using the STAR method so your answers are clear and impactful.",
    tag: "STAR Method",
  },
  {
    name: "Negotiate Like a Pro",
    icon: "TrendingUp",
    desc: "Understand your true market value and learn exactly what to say to negotiate a higher salary.",
    tag: "Negotiation",
  },
  {
    name: "Acing your Next Interview",
    icon: "Code",
    desc: "Master the system design and all the rounds with our comprehensive guide to interview questions.",
    tag: "Technical",
  },
  {
    name: "Culture Fit Mastery",
    icon: "Users",
    desc: "Learn how to align your answers with the company's core values to prove you're a great fit.",
    tag: "Values",
  },
  {
    name: "Mock Interview Setup",
    icon: "Video",
    desc: "Get the exact blueprint for setting up your environment for virtual interviews seamlessly.",
    tag: "Setup",
  },
];

export const DAILY_USES = [
  { icon: "FileText", title: "Story Boarding", desc: "Turn your experience into clear, compelling interview stories." },
  { icon: "Target", title: "Targeted Prep", desc: "Learn the frameworks to answer behavioral and situational questions." },
  { icon: "MessageCircle", title: "Mock Practice", desc: "Simulate real interview environments to build unshakeable confidence." },
  { icon: "DollarSign", title: "Offer Negotiation", desc: "Get the exact scripts to negotiate better benefits and higher pay." },
];

export const PRO_USES = [
  { icon: "Briefcase", title: "Industry Research", desc: "Learn to research companies deeply before stepping into the interview." },
  { icon: "Presentation", title: "Case Studies", desc: "Nail presentation rounds and take-home assignments with ease." },
  { icon: "UserCheck", title: "Leadership Rounds", desc: "Showcase your management and decision-making skills perfectly." },
  { icon: "TrendingUp", title: "Career Growth", desc: "Strategies to not just get the job, but position yourself for promotions." },
];

export const MODULES = [
  {
    week: "Module 1",
    title: "Resume & Profile Optimization",
    points: ["Getting past the ATS", "LinkedIn profile makeover", "Crafting a compelling summary"],
  },
  {
    week: "Module 2",
    title: "Behavioral Interview Mastery",
    points: ["Deep dive into the STAR method", "Storytelling frameworks", "Custom answer templates"],
  },
  {
    week: "Module 3",
    title: "Technical & Domain Rounds",
    points: ["Handling difficult domain questions", "Whiteboarding techniques", "Live code and system design"],
  },
  {
    week: "Module 4",
    title: "Culture Fit & Values",
    points: ["Company research strategies", "Aligning with core values", "Answering 'Why us?'"],
  },
  {
    week: "Module 5",
    title: "Mock Interviews & Setup",
    points: ["Virtual interview lighting and audio", "Body language and eye contact", "Live mock practices"],
  },
  {
    week: "Module 6",
    title: "Salary Negotiation",
    points: ["Evaluating your market worth", "Negotiation scripts that work", "Handling lowball offers"],
  },
];

export const STEPS = [
  { num: "01", icon: "FileText", title: "Story Boarding", desc: "Turn your experience into clear, compelling stories that make your interview answers memorable." },
  { num: "02", icon: "MessageSquare", title: "Interview Preparation", desc: "Learn the frameworks to answer behavioral and situational questions." },
  { num: "03", icon: "Video", title: "Mock Practice", desc: "Test your skills with live mock interviews and get actionable feedback." },
  { num: "04", icon: "TrendingUp", title: "Offer Negotiation", desc: "Get the exact scripts and strategies to negotiate a higher salary and better benefits." },
];

export const INSTRUCTOR = {
  name: "Dr. Chinmayee Abbey",
  role: "Executive Career Coach",
  photo: "/image/about.webp",
  bio: "Hi, I'm Chinmayee Abbey. I've helped professionals overcome common interview mistakes and communicate their value with confidence. I am offering a Hybrid AI Interview Coach to help you explore career opportunities, answer your questions, and guide you toward your professional goals at no cost.",
  credentials: [
    "PhD - Organizational Development",
    "ACSTH Certified - Recognized by ICF",
    "Published Author",
    "Corporate Coach",
  ],
  stats: [
    { value: "20+", label: "Years Experience" },
    { value: "2K+", label: "Professionals Helped" },
    { value: "40%", label: "Avg. Salary Increase" },
  ],
};

export const TESTIMONIALS = [
  {
    name: "Abhishek Sonkar",
    role: "Senior SDE | Fintech & Logistics",
    initials: "AS",
    quote: "I signed up for Chinmayee's 4-week guidance program covering resume review, interview prep, LinkedIn optimization, and job search strategy. What stood out was how hands-on and collaborative she was. By the end of four weeks, I walked into interviews with complete self-assurance!",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Poonam S.",
    role: "Strategic Business Analyst",
    initials: "PS",
    quote: "She has a thoughtful and encouraging approach to career coaching, taking the time to understand individual strengths and career goals. Her advice was practical, insightful, and tailored to my situation, giving me greater clarity and confidence throughout my job search.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Shreedhar A.",
    role: "Senior Infrastructure Engineer",
    initials: "SA",
    quote: "Her guidance has been truly transformative. She brings a rare combination of deep industry knowledge, practical strategies, and genuine empathy. Her insights into resume building, interview preparation, and networking strategies were invaluable.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Senthil Nathan",
    role: "Agile Coach & Program Manager",
    initials: "SN",
    quote: "Chinmayee helped me bring self-awareness and stay in my power. She helped correct my resume to get it ATS-compliant, which until then I assumed was perfect, and suggested niche segments for my job search. Highly recommended!",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Noopur Dwivedi",
    role: "Banking Data Analyst",
    initials: "ND",
    quote: "Chinmayee is a highly dedicated, reliable, and exceptionally capable professional. What truly stood out was her honesty and ability to address difficult areas with clarity and empathy, providing actionable insights that made a meaningful difference.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Arka K.",
    role: "Senior Consultant @ Sprinklr",
    initials: "AK",
    quote: "During a challenging phase when I was impacted by rightsizing, Chinmayee stepped in as a compassionate mentor. Her tailored coaching helped me regain focus, build confidence, and navigate the job search with clarity and purpose.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Vijay Rajak",
    role: "Leadership in Risk & Compliance (18+ Yrs)",
    initials: "VR",
    quote: "Her coaching sessions were highly structured, insightful, and thoughtfully tailored to my specific career goals. She provided practical guidance on role positioning, resume refinement, and interview strategy, along with clear and honest feedback.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Parneet Kaur Saluja",
    role: "Manager – Cybersecurity (Ex-ANZ)",
    initials: "PS",
    quote: "Chinmayee brings a rare mix of structured thinking, empathy, and practical insight. She took the time to truly understand my background, career goals, and constraints, providing clear, actionable guidance rather than generic advice.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Tapan Naskar",
    role: "Lead Data Scientist (PhD)",
    initials: "TN",
    quote: "Chinmayee provided me with a detailed, step-by-step plan for my job search. Before working with her, my job search was scattered. After her coaching, I approached it systematically and successfully secured my next role!",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Srinivasan Ayyan",
    role: "Vice President @ Citi Corps",
    initials: "SA",
    quote: "Working with Chinmayee has been a truly pivotal moment in my career. Her guidance on resume building, LinkedIn strategy, and interview preparation was practical, actionable, and extremely effective. She ensures real, tangible results.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Deepak Mallick",
    role: "Chief Revenue Officer @ Progility",
    initials: "DM",
    quote: "Chinmayee is intelligent, creative, energetic, empathetic, and genuinely committed to helping her clients reach their goals. The coaching conversation with her brought clarity to my thinking and empowered me to take affirmative actions.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Narasimhan Santhanarajagopalan",
    role: "Manager, SDE @ Workday",
    initials: "NS",
    quote: "One of the most impactful aspects was how Chinmayee guided me in setting clear goals, building a roadmap, sharpening every bullet point on my resume, and reimagining my presence on LinkedIn with confidence.",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
  {
    name: "Sqn Ldr Vijay Kumar Jadhav",
    role: "Operations Leader (Ex-Indian Air Force)",
    initials: "VJ",
    quote: "During my interactions I found that she is a brilliant mentor and an extremely patient coach. She is competent to build professional brand value and make it visible. I thank her and wish her all the best!",
    linkedin: "https://www.linkedin.com/in/chinmayeeabbey/",
  },
];

export const PRICING = [
  {
    name: "Starter",
    price: "Free",
    original: null,
    tagline: "Perfect for getting started",
    features: ["3 Modules", "10+ Hours of Content", "Community Access", "Basic Templates"],
    highlighted: false,
    cta: "Start for Free",
  },
  {
    name: "Professional",
    price: "₹1,999",
    original: "₹4,999",
    tagline: "Most popular: master your interviews",
    features: ["All 6 Modules", "25+ Hours of Content", "Private Community", "Mock Interview Templates", "1 Live Q&A Session"],
    highlighted: true,
    cta: "Enroll Now",
  },
  {
    name: "Career Edge",
    price: "₹14,999",
    original: "₹19,999",
    tagline: "Mastery + 1:1 Coaching",
    features: ["Everything in Professional", "1:1 Resume Review", "1:1 Mock Interview", "Priority Support", "Lifetime Access"],
    highlighted: false,
    cta: "Get Career Edge",
  },
];

export const FAQ_GROUPS = [
  {
    group: "About CHINI",
    faqs: [
      {
        q: "What is CHINI?",
        a: "CHINI is an AI interview coach trained on Dr. Chinmayee Abbey's 20+ years of executive coaching experience. She helps mid to senior professionals prepare for and crack any job interview.",
      },
      {
        q: "Who is CHINI for?",
        a: "CHINI is designed for executives and professionals (mid-level to senior) who want realistic, high-quality interview practice without booking paid sessions.",
      },
      {
        q: "Is CHINI really free?",
        a: "Yes. CHINI is 100% free to use. You can ask as many interview-related questions as you want, with no hidden charges.",
      },
      {
        q: "Do I need to sign up or create an account?",
        a: "No. You can start using CHINI immediately by clicking 'Try CHINI Now' and typing your question.",
      },
    ],
  },
  {
    group: "What CHINI Can Help You With",
    faqs: [
      {
        q: "What kinds of interviews can CHINI help me prepare for?",
        a: null,
        list: [
          "Behavioral interviews",
          "Leadership and management interviews",
          "Case interviews (high-level approach and structure)",
          "HR and fit interviews",
        ],
      },
      {
        q: "Can CHINI help me with answer frameworks?",
        a: "Yes. CHINI provides structured frameworks (like STAR, CAR, situation–action–result variants) and helps you shape your own stories and examples.",
      },
      {
        q: "Can CHINI run a mock interview with me?",
        a: "Yes. You can ask CHINI to simulate a mock interview for a specific role and level. She'll ask questions, give feedback, and help you refine your responses.",
      },
      {
        q: "Can CHINI help me with my resume or LinkedIn?",
        a: "CHINI is focused on interviewing only. For resume or LinkedIn optimization, you would need a separate service or coaching engagement. You may explore that on the main website, changeurstory.in",
        link: { text: "www.changeurstory.in", href: "https://changeurstory.in" },
      },
      {
        q: "Can CHINI help with salary negotiation?",
        a: "To a limited extent. CHINI can help you frame responses to offer discussions, prepare talking points, and think through trade-offs. For complex, multi-offer negotiation strategy, you may book a session directly with Dr. Chinmayee Abbey on the main website.",
        link: { text: "www.changeurstory.in", href: "https://changeurstory.in" },
      },
    ],
  },
  {
    group: "Privacy & Data",
    faqs: [
      {
        q: "Is my conversation with CHINI private?",
        a: "Your chats are intended for your personal use. However, avoid sharing highly sensitive personal data (like full ID numbers, confidential company details, etc.). Treat CHINI like any online tool.",
      },
      {
        q: "Does CHINI store my data?",
        a: "CHINI operates as an AI interface. Specific data storage policies depend on the platform hosting CHINI. For detailed privacy information, refer to the site's privacy policy or contact the support team.",
      },
      {
        q: "Is CHINI a replacement for a human coach?",
        a: "CHINI is a powerful practice and strategy tool, especially for interviews. She is not a full substitute for a human coach when you need deep personal branding strategy, long-term career planning, complex emotional or confidence work, or highly customized negotiation handling. Think of CHINI as your always on interview rehearsal partner, built on expert coaching methods.",
      },
      {
        q: "What if CHINI's answer doesn't fully match my situation?",
        a: "Ask follow up questions. The more context you give (role, industry, years of experience, specific challenge), the better CHINI can tailor her guidance.",
      },
      {
        q: "What topics will CHINI not cover?",
        a: "CHINI is interview-focused. She will not provide detailed resume rewriting services, full LinkedIn profile overhauls, or non-career coaching (e.g., therapy, legal, financial advice).",
      },
    ],
  },
  {
    group: "Getting Started",
    faqs: [
      {
        q: "How do I start using CHINI?",
        a: null,
        list: [
          "Click 'Try CHINI Now' on the landing page.",
          "Type your first interview-related question or scenario.",
          "Get an instant, tailored response.",
          "Ask follow ups to go deeper or run another mock round.",
        ],
      },
      {
        q: "I'm new to AI tools. Is CHINI easy to use?",
        a: "Yes. If you can type a message in a chat app, you can use CHINI. No special skills or setup are required.",
      },
      {
        q: "What if I still have questions after using CHINI?",
        a: "You can keep asking CHINI follow up questions. For deeper, personalized coaching beyond interviews, you may consider booking a session with Dr. Chinmayee Abbey or her team.",
        link: { text: "www.changeurstory.in", href: "https://changeurstory.in" },
      },
    ],
  },
];

export const NAV_LINKS = [
  { label: "Features", href: "#tools" },
  { label: "Roadmap", href: "#use-cases" },
  { label: "Try CHINI", href: "/chat" },
  { label: "Instructor", href: "#instructor" },
  { label: "FAQ", href: "#faq" },
];
